import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  // Initialize with random values immediately using lazy initialization
  const [skewPoints] = useState(() => {
    const variance = 2; // 2% variation for subtle skew
    const getRandomOffset = () => (Math.random() - 0.5) * variance;

    // Create four corner points for a subtle skewed top edge
    return {
      topLeft: getRandomOffset(),
      topRight: getRandomOffset(),
    };
  });

  return (
    <footer className="bg-black text-white py-12 relative">
      {/* Subtle skewed top edge using SVG polygon */}
      <svg
        className="absolute top-0 left-0 right-0 pointer-events-none"
        width="100%"
        height="20"
        viewBox="0 0 100 20"
        preserveAspectRatio="none"
        style={{ transform: 'translateY(-100%)' }}
      >
        <polygon
          points={`0,${20 + skewPoints.topLeft} 100,${20 + skewPoints.topRight} 100,20 0,20`}
          fill="black"
        />
      </svg>
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="mb-6 md:mb-0">
            <h3 className="text-2xl font-black mb-2">MURALIST</h3>
            <p className="text-sm text-gray-400">
              Creating beautiful murals for spaces that inspire.
            </p>
          </div>

          <div className="flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-8">
            <Link to="/" className="text-white font-semibold hover:opacity-70 transition-opacity">Home</Link>
            <Link to="/about" className="text-white font-semibold hover:opacity-70 transition-opacity">About</Link>
            <Link to="/gallery" className="text-white font-semibold hover:opacity-70 transition-opacity">Gallery</Link>
            <Link to="/contact" className="text-white font-semibold hover:opacity-70 transition-opacity">Contact</Link>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-sm text-gray-500">
          <p>© {currentYear} Muralist. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;